let permissions = {
  title: 'Permissões',
  title_s: 'Permissão',
  unit: 'Permissão',
  icon: 'mdi-account-network',
  model: {
    home: 'Página Home',
    scheduler: {
      title: 'Agenda',
      only_me: 'Apenas Agendamentos Próprios',
      launches: 'Lançamentos',
      calendar: 'Calendário',
      list: 'Lista'
    },
    orders: {
      title: 'Página Vendas',
      by_type: 'Limitar por Tipo',
      type: 'Tipo',
      by_status: 'Limitar por Status',
      by_created: 'Apenas Pedidos Próprios',
      viewprices: 'Ver Preços',
      historyinfo: 'Ver Históricos',
      comissions: 'Definir Comissões'
    },
    catalog: {
      title: 'Página Catálogo',
      stock: 'Controle de Estoque',
      services: 'Serviços',
      items: 'Produtos',
      categories: 'Categorias',
      additional: 'Adicionais'
    },
    customers: 'Página Clientes',
    financial: {
      title: 'Página Financeiro',
      summary: 'Resumo',
      overview: 'Visão Geral (Valores)',
      cash_flow: 'Fluxo de Caixa',
      bills: 'Contas',
      salary: 'Remunerações',
      reports: 'Relatórios'
    },
    users: 'Página Profissionais',
    historic: {
      title: 'Página Histórico',
      orders: 'Vendas',
      catalog: 'Catálogo',
      customers: 'Clientes',
      graphs: 'Gráficos',
      statistics: 'Estatísticas'
    },
    config: {
      title: 'Página Configurações',
      app: 'App',
      themes: 'Temas',
      permissions: 'Permissões',
      defaults: 'Predefinições'
    },
    profile: 'Página Perfil',
    admin: 'Painel do Desenvolvedor *',
    status: {
      from: 'De',
      to: 'Até',
      min: 'Mínimo',
      max: 'Máximo'
    },
    actions: {
      title: 'Ações',
      view: 'Ver',
      repeat: 'Repetir',
      new: 'Criar Novo',
      edit: 'Editar',
      status: 'Mudança de Status',
      paid: 'Registrar Pagamentos',
      cancel: 'Cancelar',
      delete: 'Excluir'
    }
  },
  new: {
    title: 'Nova Permissão',
    close: 'Fechar',
    color: 'Cor',
    no_color: 'Sem Cores',
    colors: {
      blue: 'Azul',
      indigo: 'Indigo',
      amber: 'Âmbar ',
      orange: 'Laranja',
      lightgreen: 'Verde Claro',
      deeppurple: 'Roxo Escuro',
      red: 'Vermelho',
      pink: 'Rosa',
      purple: 'Roxo',
      cyan: 'Ciano',
      teal: 'Azul Petróleo',
      green: 'Verde'
    },
    rules: {
      titleRules: [
        v => !!v || 'Título é obrigatório',
        v => (v && v.length <= 27) || 'O Título deve ter menos que 27 caracteres'
      ]
    },
    presets: {
      title: 'Predefinições',
      customer: 'Cliente',
      waiter: 'Garçom',
      deliveryman: 'Entregador',
      kitchen: 'Cozinha',
      cashier: 'Caixa',
      manager: 'Gerente',
      administrator: 'Administrador'
    }
  },
  edit: {
    title: 'Editar Permissão'
  },
  actions: {
    new: 'Novo',
    edit: 'Editar',
    save: 'Salvar',
    delete: 'Excluir'
  },
  dialog: {
    deleteConfirm: 'Tem certeza que deseja excluir a Permissão'
  },
  datatable: {
    search: 'Pesquisar',
    no_data: 'Nenhuma Permissão encontrada.',
    no_results: 'Nenhum resultado encontrado',
    items_per_page: 'Permissões por página',
    headers: {
      id: 'ID',
      title: 'Título',
      action: 'Ações'
    }
  },
  messages: {
    error: {
      not_found: 'Permissão não encontrada'
    }
  }
}

export default permissions
